import { observer } from 'mobx-react';
import Box from '@mui/material/Box';
import { createTheme, ThemeProvider, styled } from '@mui/material/styles';
import { useEffect, useState } from 'react';
import { Button, Card, CardContent, Drawer, Stack } from '@mui/material';
import { AppNavbar } from '../../components/AppNavbar';
import { UsersList } from '../../components/UsersList';
import { NewUserDialog } from '../../components/NewUserDialog';

const defaultTheme = createTheme({
  typography: {
    button: {
      textTransform: 'none',
    },
  },
});

const CustomButton = styled(Button)({
  backgroundColor: '#F07B0E',
  color: '#fff',
  '&:hover': {
    backgroundColor: '#d67e2d',
  },
  width: 'fit-content',
  height: '34px',
});

const SubNavBarCard = styled(Card)({
  top: '49px',
  position: 'fixed',
  width: '-webkit-fill-available',
  zIndex: '10',
  height: '45px',
  minHeight: '45px',
});

export const UserManagement = observer(() => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [toggleUserDetail, setToggleUserDetail] = useState(null);
  const [selectedLeads, setSelectedLeads] = useState([]);
  const [toggleNewUserDialog, setToggleNewUserDialog] = useState(false);
  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  const handleSelectedRowChange = (leadIds) => {
    setSelectedLeads(leadIds.map((item) => parseInt(item)));
  };

  const handleShowUserDetails = (user) => {
    setToggleUserDetail(user);
    setToggleNewUserDialog(true);
  };

  return (
    // <ThemeProvider theme={defaultTheme}>
    <Card>
      <AppNavbar></AppNavbar>
      <Box sx={{ boxShadow: 'unset', overflow: 'auto' }}>
        <Stack direction="column">
          <SubNavBarCard>
            <CardContent sx={{ pt: '6px !important', pb: '6px !important' }}>
              <Stack justifyContent="space-between" direction="row" spacing={2}>
                <Stack></Stack>
                <Stack justifyContent="flex-end" direction="row" spacing={2}>
                  <CustomButton
                    onClick={() => {
                      setToggleUserDetail(null);
                      setToggleNewUserDialog(true);
                    }}
                    variant="contained"
                  >
                    Create User
                  </CustomButton>
                </Stack>
              </Stack>
            </CardContent>
          </SubNavBarCard>
          <Box
            flexGrow={1}
            sx={{
              top: '95px',
              position: 'absolute',
              width: '-webkit-fill-available',
              p: '25px',
              boxShadow: 'unset',
              backgroundColor: '#D7E3EF',
            }}
          >
            <UsersList
              handleSelectedRowChange={handleSelectedRowChange}
              toggleUserDetails={handleShowUserDetails}
            ></UsersList>
          </Box>
        </Stack>
      </Box>
      <NewUserDialog
        showNewUserDialog={toggleNewUserDialog}
        handleShowNewUserDialog={() => setToggleNewUserDialog(false)}
        userDetails={toggleUserDetail?.original}
      ></NewUserDialog>
    </Card>
    // </ThemeProvider>
  );
});
